<template>
  <div class="row jipvio-dashboard">
    <div class="col-12">
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-20">회원관리 > 임차인</h4>
        <div class="card-title ml-20 mb-50 row">
          <div class="col-sm-6 pl-0">
            <h4 class="fl ttl-label mr-20">검색</h4>
            <fg-input>
              <el-select
                class="select-primary mb-3 fl mr-10"
                style="width: 200px"
                v-model="searchStd"
                placeholder="검색기준"
                @input="searchSetData(searchStd)"
              >
                <el-option
                  class="select-default"
                  v-for="tc in tableColumns"
                  :key="tc.label"
                  :label="tc.label"
                  :value="tc.label"
                >
                </el-option>
              </el-select>
              <el-autocomplete
                type="search"
                class="mb-3 fl"
                clearable
                style="width: 200px"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
                :fetch-suggestions="querySearchAsync"
                @select="handleSelect"
              >
              </el-autocomplete>
            </fg-input>
          </div>
          <div class="col-sm-6 pl-0 dashbrd-el-label">
            <h4 class="fl ttl-label mr-20">회원구분</h4>
            <el-checkbox-group v-model="checkList">
              <el-checkbox label="일반" checked></el-checkbox>
              <el-checkbox label="카카오톡"></el-checkbox>
              <el-checkbox label="네이버"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <card>
          <h4 class="card-title ml-20">임차인 회원 목록</h4>
          <div>
            <el-table stripe style="width: 100%" :data="tableData">
              <el-table-column
                v-for="column in filteredColumns()"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                align="center"
                :sortable="column.sortable"
              >
              </el-table-column>

              <el-table-column
                :min-width="135"
                fixed="right"
                label="작업"
                align="center"
              >
                <template v-slot="props">
                  <div class="table-actions">
                    <router-link to="/mypage/admin/mem/lee/detail">
                      <n-button @click="printData(props.$index, props.row)">
                        수정
                      </n-button>
                    </router-link>
                    <n-button type="danger" style="margin-left:10px;">
                      삭제
                    </n-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-20"
          >
            <div>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <n-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.totalCnt"
            >
            </n-pagination>
          </div>
        </card>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  Input,
  Button,
  Radio,
  RadioGroup,
  Popover,
  Checkbox,
  CheckboxGroup,
  Autocomplete
} from "element-ui";
import { Pagination as NPagination } from "@/components";
import { Button as NButton } from "@/components";
import card from "@/components/Cards/Card.vue";
import propApi from "@/service/property";

import { createNamespacedHelpers } from "vuex";

const {
  mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    NPagination,
    NButton,
    card,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popover.name]: Popover,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Autocomplete.name]: Autocomplete
  },
  created() {
    console.log("======문의내역");
    console.log(this.sessionUserInfo);
    this.getAllProperty();
  },

  computed: {
    ...sessionMapGetters({
      sessionUserInfo: "getUserInfo"
    }),
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.totalCnt;
    }
  },
  data() {
    return {
      checkList: ["Option A"],
      activeName: "일반",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        totalCnt: 0,
        totalPages: 10
      },
      searchStd: null,
      searchQuery: "",

      tableColumns: {
        NumBer: {
          prop: "number",
          label: "번호",
          minWidth: 125,
          sortable: true,
          vif: true
        },
        SignupTyPe: {
          prop: "signUpType",
          label: "회원구분",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        MemberTyPe: {
          prop: "memberType",
          label: "회원종류",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        MemberName: {
          prop: "memberName",
          label: "성명",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        MemberEmail: {
          prop: "memberEmail",
          label: "이메일",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        SignupDate: {
          prop: "signUpDate",
          label: "가입일",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        CurrentLogDate: {
          prop: "currentLogDate",
          label: "최근접속일",
          minWidth: 110,
          sortable: true,
          vif: true
        }
      },
      sor: false,
      tableData: [
        {
          number: 1,
          signUpType: "일반",
          memberType: "임대인",
          memberName: "홍길동",
          memberEmail: "add@gmail.com",
          signUpDate: "2020-10-31",
          currentLogDate: "2021-02-04",
          signUpStatement: "가입요청"
        },
        {
          number: 2,
          signUpType: "카카오톡",
          memberType: "임대인",
          memberName: "홍길동",
          memberEmail: "add@gmail.com",
          signUpDate: "2020-10-31",
          currentLogDate: "2021-02-04",
          signUpStatement: "가입요청"
        },
        {
          number: 3,
          signUpType: "네이버",
          memberType: "임대인",
          memberName: "홍길동",
          memberEmail: "add@gmail.com",
          signUpDate: "2020-10-31",
          currentLogDate: "2021-02-04",
          signUpStatement: "가입승인"
        }
      ],

      searchData: "",
      timeout: null
    };
  },
  methods: {
    searchSetData(value) {
      this.searchQuery = "";
      let selectData = [];
      if (value == "번호") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.number);
        });
      } else if (value == "회원구분") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.signUpType);
        });
      } else if (value == "회원종류") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.memberType);
        });
      } else if (value == "성명") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.memberName);
        });
      } else if (value == "이메일") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.memberEmail);
        });
      } else if (value == "가입일") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.signUpDate);
        });
      } else if (value == "최근접속일") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(String(ele.currentLogDate));
        });
      }
      /* 중복 확인 및 제거 */
      selectData = Array.from(new Set(selectData));

      /* value값으로 만들어 주지 않으면 읽지 못함 */
      if (selectData.length > 0) {
        let values = [];
        for (let i = 0; i < selectData.length; i++) {
          values.push({
            label: value,
            value: selectData[i]
          });
        }
        this.searchData = values;
      }
      console.log("=======================this.searchData");
      console.log(this.searchData);
    },
    querySearchAsync(queryString, cb) {
      let searchResult = this.searchData;

      let results = queryString
        ? searchResult.filter(this.createFilter(queryString))
        : searchResult;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300);
    },
    createFilter(queryString) {
      return el => {
        return el.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      console.log("=================handleSelect");
      if (this.searchStd == "번호") {
        this.Number = item.value;
      } else if (this.searchStd == "회원구분") {
        this.signUpType = this.selects.APV_Type[item.value];
      }
      // this.getAllProperty();
    },

    printData(index, row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      console.log("here");
      console.log(index);
      console.log(row);
      console.log(indexToDelete);
    },

    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },

    async getAllProperty() {
      const pagingReq = {
        pageNo: this.pagination.currentPage - 1,
        sizePerPage: this.pagination.perPage,
        swLat: 37.66258399481432,
        swLng: 127.04401962842194,
        neLat: 37.66762719185185,
        neLng: 127.04979178950516
      };

      const res = await propApi.getAllProperty(pagingReq);

      this.pagination.perPage = res.pagingInfo.size;
      this.pagination.currentPage = res.pagingInfo.pageNo + 1;
      this.pagination.totalCnt = res.pagingInfo.totalCnt;
      this.pagination.totalPages = res.pagingInfo.totalPages;
      this.tableData = res.payload;
    },
    handleClick(tab, event) {
      console.log("==============tab");
      console.log(tab);
      console.log("==============event");
      console.log(event);
    },

    filteredColumns() {
      const newTbColumns = _.cloneDeep(this.tableColumns);
      for (let key in newTbColumns) {
        if (newTbColumns[key].vif == false) {
          delete newTbColumns[key];
        }
      }
      console.log(newTbColumns);
      return newTbColumns;
    }
  },
  mounted() {},
  watch: {
    "pagination.currentPage"(newValue, oldValue) {
      this.getAllProperty();
    },
    "pagination.perPage"(newValue, oldValue) {
      this.pagination.currentPage = 1;
      this.getAllProperty();
    }
  }
};
</script>
<style></style>
